import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
// eslint-disable-next-line
import MobileStepper from '@material-ui/core/MobileStepper';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import CircularProgress from '@material-ui/core/CircularProgress';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
// eslint-disable-next-line
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
// eslint-disable-next-line
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import { I18n } from 'aws-amplify';
import detecting from './img/connect-guide-img-02.png';
import "./smartdevice.css";
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';

var width = window.outerWidth || document.body.clientWidth;

const styles = theme => ({
  root: {
    flexGrow: 1,
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    height: 50,
    paddingLeft: theme.spacing.unit * 4,
    marginBottom: 20,
    backgroundColor: theme.palette.background.default,
  },
  instructions: {
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit,
  },
  progress: {
    margin: theme.spacing.unit * 2,
  },
});

class ThetaDetecting extends React.Component {

  timer;
    
  state = {
    activeStep: 0,
    completed: 0,
    open: false,
    isbind: false,
    devicename: 'THETAYL',
  };
  
  componentWillUnmount() {
    clearInterval(this.timer);
  }
  
  handleNext = () => {
    if (this.state.activeStep === 0) {
      this.handleClickLoading()
    } else if (this.state.activeStep === 1) {
      this.handleToHomePage()
    }

    this.setState(prevState => ({
      activeStep: prevState.activeStep + 1,
    }));
  };

  handleBack = () => {
    clearInterval(this.timer);

    this.setState(prevState => ({
      activeStep: prevState.activeStep - 1,
      completed: 0
    }));
    if (this.state.activeStep === 0) {
      this.props.history.push('/index.html');
    }
  };

  handleReset = () => {
    clearInterval(this.timer);
    this.setState({
      activeStep: 0,
      completed: 0
    });
  };

  handleToHomePage = () => {
    this.props.onPostData(this.props.ranking, this.props.bind[0],false,this.props.checkedB);
    this.props.history.push('/index.html')
  };

  handleChange = event => {
      this.setState({serialnumber: event.target.value});
  };
  
  handleChange2 = event => {
      const updatebind = this.props.bind;
      const keys = event.target.id.split('-');
      const _bind = updatebind.map((item,i) => {
          if (item.serialnumber === keys[1]) {
              if (keys[0] === 'DisplayName') {
                  item.displayname = event.target.value;
              } else if (keys[0] === 'Comment') {
                  item.comment = event.target.value;
              }
          }
          return item;
      });
      this.setState({bind: _bind});
  };

  handleDeviceNameChange = event => {
      this.setState({devicename: event.target.value});
  };

  updateState(state){
        this.setState(state);
    }
    
  handleClickLoading(){
    this.props.onUpdate(this.state.serialnumber, this.state.devicename);
    clearInterval(this.timer);
    this.timer = setInterval(this.progress, 1000);
    this.setState({
      completed: 0
    });
  };
  
  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleCloseBack = () => {
    this.handleBack();
    this.setState({ open: false });
  };
  
  handleCloseReStart = () => {
    this.timer = setInterval(this.progress, 1000);
    this.setState({
      completed: 0,
      open: false
    });
  };
  
  handleClickBind = () => {
    this.setState({ isbind: true });
  };

  handleCloseBind = () => {
    this.setState({ isbind: false });
  };
  
  disableButton = (stepIndex) => {
    let disable = false;
    switch (stepIndex) {
      case 0:
        if (this.state.serialnumber === undefined || this.state.serialnumber.length === 0) {
          disable = true;
        }
        break;
      case 1:
        if (this.props.bind !== undefined && this.props.bind.length !== 0) {
          if (this.props.bind[0].displayname === undefined || this.props.bind[0].displayname.length === 0) {
            disable = true
          }
        } else {
          disable = true;
        }
        break;
      default:
        break;
    }
    return disable;
  };
  
  progress = () => {
    if (this.props.bind === undefined || this.props.bind.length === 0) {
      const { completed } = this.state;
      this.props.onUpdate(this.state.serialnumber, this.state.devicename);

      if (completed >= 100) {
        this.handleClickOpen();
        clearInterval(this.timer);
      } else {
        this.handleClickBind();
        this.setState({ completed: completed + 5/3 });
      }

    } else {
      clearInterval(this.timer);
    }
  };
  
  getStepContent(stepIndex, serialnumber, devicename, classes) {
    switch (stepIndex) {
      case 0:
        return <ol>
        <div className="parent_inputssid">
          <div className="inputssid">
          <form>
            <FormControl className={classes.formControl}>
            <InputLabel htmlFor="select_theta_version_helper">SSID</InputLabel>
              <Select
                value={devicename}
                onChange={this.handleDeviceNameChange}
                inputProps={{ 
                  name: "version", 
                  id: "select_theta_version_helper" 
                }}
                displayEmpty
                name="version"
                className={classes.selectEmpty}
              >
                <MenuItem value={"THETAYL"}>THETAYL</MenuItem>
                <MenuItem value={"THETAYN"}>THETAYN</MenuItem>
              </Select>
              </FormControl>
          </form>
          </div>
          <div className="inputtextssid">
          <TextField
            margin="normal"
            value={serialnumber}
            type="number"
            placeholder={I18n.get("network id")}
            onChange={this.handleChange}
          />
          </div>
        </div>
        <p className="message">{I18n.get("input serial number")}</p>
        </ol>;
      case 1:
        return <div>{this.props.bind === undefined ? (
        <div>
        <div className="circular_progress">
        <CircularProgress className={classes.progress} variant="static" value={this.state.completed} />
        </div>
        <Dialog
          open={this.state.open}
          onClose={this.handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{I18n.get("failed to detect")}</DialogTitle>
          <DialogActions >
            <Button onClick={this.handleCloseBack} color="primary">
              {I18n.get("return")}
            </Button>
            <Button onClick={this.handleCloseReStart} color="primary" autoFocus>
              {I18n.get("retry")}
            </Button>
          </DialogActions>
        </Dialog>
        </div>
        ):this.props.bind.length === 0 ?(
        <div>
        <div className="circular_progress">
        <CircularProgress className={classes.progress} variant="static" value={this.state.completed} />
        </div>
        <Dialog
          open={this.state.open}
          onClose={this.handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle  id="alert-dialog-title">{I18n.get("failed to detect")}</DialogTitle>
          <DialogActions>
            <Button onClick={this.handleCloseBack} color="primary">
              {I18n.get("return")}
            </Button>
            <Button onClick={this.handleCloseReStart} color="primary" autoFocus>
              {I18n.get("retry")}
            </Button>
          </DialogActions>
        </Dialog>
        </div>
        ):(
        <ol>
        <Dialog
          open={this.state.isbind}
          onClose={this.handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{I18n.get("theta is detected")}</DialogTitle>
          <DialogActions >
            <Button onClick={this.handleCloseBind} color="primary">
              OK
            </Button>
          </DialogActions>
        </Dialog>
        <div className="change_displayname">
          {this.props.bind.map((item,i) => (
              <TextField id={`DisplayName-${item.serialnumber}`}
                  style={{width: '150px' }}
                  placeholder="DisplayName"
                  value={`${item.displayname}`}
                  onChange={this.handleChange2}/>
          ))}
        </div>
        </ol>)
        }
        {this.props.bind === undefined || this.props.bind.length === 0 ?<div className="image">
        <img className="detecting" src={detecting} alt="detecting" />
        <p className="message_center">{I18n.get("detect theta")}</p>
        </div>
        :<p className="message">{I18n.get("name introduction")}</p>}
        </div>
        ;
      default:
        return 'Uknown stepIndex';
    }
  }

  render() {
    // eslint-disable-next-line
    const { classes,theme } = this.props;
    const steps = ['Register a new Theta', 'Naming my Theta'];
    // eslint-disable-next-line
    const maxSteps = steps.length;

    const { activeStep,serialnumber, devicename } = this.state;
    
    if (width > 320){
      return (
        <div className={classes.root}>
        <ul className="header_short">
          <li className="back_button"><Button style={{fontSize: 'small' }} size="medium" onClick={this.handleBack}>{I18n.get("cancel")}</Button></li>
          <li className="title_short"><p>{I18n.get("register header title")}</p></li>
          <li className="next_button"><Button style={{fontSize: 'small' }} size="medium" onClick={this.handleNext} disabled={this.disableButton(activeStep)?true:false}>{I18n.get("next")}</Button></li>
        </ul>
        <div>
          <div className="parent">
            <div className={classes.instructions}>{this.getStepContent(activeStep,serialnumber, devicename, classes)}</div>
          </div>
        </div>
        </div>
      )
    } else {
       return (
        <div className={classes.root}>
        <ul className="header_short">
          <li className="back_button"><Button onClick={this.handleBack}>{I18n.get("cancel")}</Button></li>
          <li className="title_short"><p>{I18n.get("register header title")}</p></li>
          <li className="next_button"><Button onClick={this.handleNext} disabled={this.disableButton(activeStep)?true:false}>{I18n.get("next")}</Button></li>
        </ul>
        <div>
          <div className="parent">
            <div className={classes.instructions}>{this.getStepContent(activeStep,serialnumber, devicename, classes)}</div>
          </div>
        </div>
        </div>
      ) 
    }
  }
}
ThetaDetecting.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

withStyles.propTypes = {
    categoryId: PropTypes.string,
    onMount: PropTypes.func.isRequired,
    onUpdate: PropTypes.func.isRequired,
　  classes: PropTypes.object.isRequired,
};

withStyles.defaultProps = {
    categoryId: '2',
    bind: undefined
};

export default withStyles(styles, { withTheme: true })(ThetaDetecting);



// WEBPACK FOOTER //
// ./src/components/ThetaDetecting.js